import { render, staticRenderFns } from "./AcceptTask.vue?vue&type=template&id=0c4e8616"
import script from "./AcceptTask.vue?vue&type=script&lang=js"
export * from "./AcceptTask.vue?vue&type=script&lang=js"
import style0 from "./AcceptTask.vue?vue&type=style&index=0&id=0c4e8616&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports